import React from "react";
import colors from "../../utils/colors";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import styled from "styled-components";

const Layout = styled.div`
  font-family: "Oswald" sans-serif;
  background: #f6f6f6;
  .banner {
    @media (max-width: 767px) {
      padding: 5%;
    }
  }
`;

function Appreciation() {
  return (
    <>
      <Layout>
        <div style={styles.banner} className="banner">
          <h3 style={styles.title}>
            THANKS FOR THE GIFT. WE REALLY APPRECIATE IT.
          </h3>

          <span style={styles.text}>
            Lorem ipsum dolor adipiscing elit. Integer ultrices malesuada ante
            quis pharetra. Nullam <br /> non bibendum dolor. Ut vel turpis
            accumsan, efficitur Lorem ipsum dolor adipiscing elit. Integer{" "}
          </span>
          <p>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{
                  fontSize: 19,
                  marginLeft: -5,
                  color: "white",
                }}
              />
              <span className="white-line"></span>
            </HeartStyle>
          </p>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
  },
  text: {
    fontSize: "120%",
    fontWeight: 500,
    marginBottom: 24,
    color: colors.black,
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
  title: {
    marginTop: 60,
    letterSpacing: 3,
    fontSize: "145%",
    fontWeight: 700,
    marginBottom: 24,
    color: colors.black,
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
};

export default Appreciation;
